export default {"src":"/_next/static/media/HASI.72bac2b1.svg","height":18,"width":18};